import InternalCapiClient from "./InternalCapiClient.generated";
import rawInternalCapiClient from "../rawClients/rawInternalCapiClient";
const internalCapiClient = new InternalCapiClient(rawInternalCapiClient);
export default internalCapiClient;
